import React from 'react';
import styled from 'styled-components';

/**
 * 패키지 금액 입력 컴포넌트
 */
const EsApplyPckgNavPriceBlock = styled.div`
    position: relative;
    margin-left: -40px;
    width: 50%;
    float: left;
`;

const EsApplyPckgNavPrice = () => {
    return (
        <EsApplyPckgNavPriceBlock>

        </EsApplyPckgNavPriceBlock>
    );
};

export default EsApplyPckgNavPrice;